export const LAST_VISIT_THROTTLE_MS = 30 * 60 * 1000;

export const shouldUpdateLastVisit = (lastWrite, now = Date.now()) =>
  !lastWrite || now - Number(lastWrite) >= LAST_VISIT_THROTTLE_MS;
